module.exports = __webpack_public_path__ + "img/Printer.6db7f901.svg";